import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import type { IModalDialogContent, ModalDialogOptions, ModalWindow } from '@components/Modal.tsx';
import { ModalButtonType } from '@components/Modal.tsx';

export type CreateUserResult = {
  displayName: string;
  login: string;
  password: string;
};

@observer
export class CreateUserDialog extends React.Component implements IModalDialogContent<CreateUserResult> {
  @observable private _displayName = '';
  @observable private _login = '';
  @observable private _password = '';
  @observable private _error = '';

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  getModalOptions(window: ModalWindow<CreateUserResult>): ModalDialogOptions<CreateUserResult> {
    return {
      title: 'Create New User',
      width: '420px',
      closeByEscape: true,
      closeOnClickOutside: false,
      buttons: [
        {
          title: 'Create',
          type: ModalButtonType.Add,
          color: 'primary',
          onClick: () => {
            if (!this._login.trim() || !this._password.trim()) {
              this._setError('Login and password are required');
              return;
            }
            window.setPayload({
              displayName: this._displayName.trim(),
              login: this._login.trim(),
              password: this._password,
            });
            window.close(ModalButtonType.Add);
          },
        },
        {
          title: 'Cancel',
          type: ModalButtonType.Cancel,
          onClick: () => window.close(ModalButtonType.Cancel),
        },
      ],
    };
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
        {this._error && (
          <div style={{ color: 'var(--danger-color)', fontSize: '13px' }}>{this._error}</div>
        )}
        <div className="form-row">
          <label>Display Name</label>
          <input
            className="form-control"
            placeholder="Display Name"
            value={this._displayName}
            onChange={this._onDisplayNameChange}
            autoFocus
          />
        </div>
        <div className="form-row">
          <label>Login <span style={{ color: 'var(--danger-color)' }}>*</span></label>
          <input
            className="form-control"
            placeholder="Login"
            value={this._login}
            onChange={this._onLoginChange}
          />
        </div>
        <div className="form-row">
          <label>Password <span style={{ color: 'var(--danger-color)' }}>*</span></label>
          <input
            className="form-control"
            type="password"
            placeholder="Password"
            value={this._password}
            onChange={this._onPasswordChange}
          />
        </div>
      </div>
    );
  }

  @action.bound private _onDisplayNameChange(e: React.ChangeEvent<HTMLInputElement>) { this._displayName = e.target.value; }
  @action.bound private _onLoginChange(e: React.ChangeEvent<HTMLInputElement>) { this._login = e.target.value; }
  @action.bound private _onPasswordChange(e: React.ChangeEvent<HTMLInputElement>) { this._password = e.target.value; }
  @action private _setError(msg: string) { this._error = msg; }
}
